import React, { useState, useMemo } from 'react';
import { FormControl, Select, MenuItem, InputLabel, ListSubheader, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = ({ label, category, value, selectValues = [], valueKey, idKey, handleFilterSelected }) => {
  const [searchText, setSearchText] = useState('');

  // Verificar que selectValues es un array
  if (!Array.isArray(selectValues)) {
    console.error(`Expected selectValues to be an array, but got ${typeof selectValues}`);
    return null;
  }

  const containsText = (text, searchTextString) => {
    if (searchTextString !== '') {
      return text?.includes(searchTextString);
    }
    return true;
  };

  const displayedOptions = useMemo(
    () => {
      return selectValues.filter((option) => {
        const idMatches = option[idKey].toString().toLowerCase().includes(searchText.toLowerCase());
        const valueMatches = option[valueKey].toLowerCase().includes(searchText.toLowerCase());

        // Retorna verdadero si coincide con id o valor
        return idMatches || valueMatches;
      });
    },[selectValues, valueKey, searchText]
  );

 
  return (
    <FormControl sx={{ width: '95%' }}>
      <InputLabel id="search-select-label">{label}</InputLabel>
      <Select
        MenuProps={{ autoFocus: false }}
        labelId={`search-select-${label}-label`}
        id={`search-select-${label}`}
        value={value}
        label="Options"
        onChange={(e) => {
          handleFilterSelected(category, e.target.value);
        }}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            size="small"
            autoFocus
            placeholder="Teclea para buscar..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {displayedOptions.map((selectValue, i) => (
          <MenuItem key={i} value={selectValue[idKey]}>
            { `${selectValue[idKey]} - ${selectValue[valueKey]}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SearchInput;
